import React from "react";

const RadioButton = ({
	id,
	label,
	name,
	register,
	validationSchema,
	...inputProps
}) => {
	return (
		<div className="flex items-center mb-4 mt-2 mr-4">
			<input
				className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
				id={id}
				type="radio"
				{...inputProps}
				{...register(name, validationSchema)}
			/>
			<label htmlFor={id} className="ml-2 text-sm font-medium text-gray-900">
				{label}
			</label>
		</div>
	);
};

export default RadioButton;
